import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { DropdownMenu, Button } from '@3plearning/react-components';
import { FilterListWrapper, FilterWrapper, InputWrapper } from './styled';
import {
  getClassrooms,
  getGroups,
  setDefaultValues,
  searchSelectedClass,
  searchSelectedGroup,
  getStudents
} from './filters-util';
import {
  filteredStudents,
  updateSelectedClassRoom,
  updateSelectedClassRoomGroup
} from '../../containers/upf-assign/upf-assign-actions';
import { activateModal } from '../../containers/modal-manager/modal-manager-actions';
import createLinkUpfModal from '../../containers/link-upf-modal/link-upf-modal';
import { isAssessmentsReadOnly } from '../../helpers/utils';
import { useTracking } from '../../analytics';

const Filters = (props) => {
  const dispatch = useDispatch();
  const { trackClassFilter, trackGroupFilter, trackFillLearningGaps } = useTracking();
  const { classrooms = [], i18n, lastSelectedClass = '', lastSelectedGroup = '' } = props;
  const [classes, setClassrooms] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedClass, setDefaultClassOption] = useState(null);
  const [selectedGroup, setDefaultGroupOption] = useState(null);
  const classLabel = i18n.t`Class`;
  const groupLabel = i18n.t`Group`;
  const defaultGroupValue = { value: '-1', label: i18n.t`Whole class` };
  const lastSelectClassValue = searchSelectedClass(classrooms, lastSelectedClass);
  const lastSelectGroupValue = searchSelectedGroup(classrooms, lastSelectedClass, lastSelectedGroup);
  useEffect(() => {
    if (classrooms.length > 0) {
      setClassrooms(getClassrooms(classrooms));
      setGroups(getGroups(lastSelectedClass || classrooms[0].id, classrooms, i18n));
      if (lastSelectClassValue) {
        setDefaultClassOption(lastSelectClassValue);
        dispatch(updateSelectedClassRoom(lastSelectClassValue));
      } else {
        const classOption = setDefaultValues(true, classrooms);
        setDefaultClassOption(classOption);
        dispatch(updateSelectedClassRoom(classOption));
      }
      if (lastSelectGroupValue) {
        setDefaultGroupOption(lastSelectGroupValue);
        dispatch(updateSelectedClassRoomGroup(lastSelectGroupValue));
      } else {
        setDefaultGroupOption(defaultGroupValue);
        dispatch(updateSelectedClassRoomGroup(defaultGroupValue));
      }
      dispatch(filteredStudents(getStudents(classrooms[0].id, '-1', classrooms)));
    }
  }, [classrooms]);

  const onClassroomChange = (option) => {
    trackClassFilter();
    setDefaultClassOption(option);
    dispatch(updateSelectedClassRoom(option));
    setGroups(getGroups(option.value, classrooms, i18n));
    setDefaultGroupOption(defaultGroupValue);
    dispatch(filteredStudents(getStudents(option.value, '-1', classrooms)));
  };

  const onGroupChange = (option) => {
    trackGroupFilter();
    setDefaultGroupOption(option);
    dispatch(updateSelectedClassRoomGroup(option));
    dispatch(filteredStudents(getStudents(selectedClass.value, option.value, classrooms)));
  };

  function GetClassFilters() {
    if ((classes instanceof Array) && classes.length === 1) {
      return (
        <InputWrapper type="text" value={classes[0].label} readOnly />
      );
    } return (<DropdownMenu
      key="ddlClassrooms"
      options={classes}
      selectedOption={selectedClass || classes[0]}
      onSelectOption={onClassroomChange}
    />);
  }

  const openLearningGapsModal = () => {
    trackFillLearningGaps();
    dispatch(activateModal(createLinkUpfModal(i18n, selectedGroup)));
  };

  return (<FilterListWrapper>
    <FilterWrapper data-name="class-selector">
      <div>{classLabel}</div>
      <GetClassFilters />
    </FilterWrapper>
    <FilterWrapper data-name="group-selector">
      <div>{groupLabel}</div>
      <DropdownMenu
        key="ddlGroups"
        options={groups}
        selectedOption={selectedGroup || groups[0]}
        onSelectOption={onGroupChange}
      />
    </FilterWrapper>
    <Button
      className="learningGapsButton"
      text={i18n.t`Fill learning gaps`}
      type={Button.LOZENGE}
      onClick={openLearningGapsModal}
      disabled={isAssessmentsReadOnly()}
    />
  </FilterListWrapper>);
};

Filters.propTypes = {
  classrooms: PropTypes.array.isRequired,
  i18n: PropTypes.object,
  lastSelectedClass: PropTypes.string,
  lastSelectedGroup: PropTypes.string
};

Filters.whyDidYouRender = false;

export default Filters;
